<template>
  <v-container :fill-height='loading'>
   <v-layout v-if="loading"
      align-center
      justify-space-around
      wrap
      fill-height
    style="background:var(--background-grey); height:100vh;"
      >
      <v-progress-circular
          indeterminate
          color="primary"
          :size="50">
          </v-progress-circular>
      </v-layout>
    <v-layout row wrap v-else>
      <v-flex xs12>
        <div class="add-page-head ">
          <span :class="{'display-4 section-head d-block' : $vuetify.breakpoint.xsOnly, 'display-3 section-head d-block' : !$vuetify.breakpoint.xsOnly}">Notifications</span>
          <span class="body-small font-weight-bold pt-1 d-block">Review what's been happening on your account.</span>
        </div>
      </v-flex>
      <v-flex xs12 v-if="error">
        <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
      </v-flex>
      <v-flex xs12>
          <div class="app-panel" :class="{'white px-1 pb-4 pt-4' : $vuetify.breakpoint.xsOnly, 'white px-3 pb-4 pt-4' : !$vuetify.breakpoint.xsOnly}">
          <v-data-table
              :headers="headers"
              :items="notifications"
              hide-actions
              hide-headers
              :search="search"
              class="datatable"
              :pagination.sync="pagination"
              :loading="loading"
            >
            <template slot="items" slot-scope="props">
              <tr @click="$router.push(`${props.item.link}`)" style="cursor:pointer;">
                <td class="text-xs-left body-small"><v-icon style="font-size:18px;" color="accent" v-if="props.item.status === 'unread'">fiber_manual_record</v-icon></td>
                <td class="text-xs-left body-small pt-1 pb-1">{{props.item.message}}</td>
                <td class="text-xs-left body-small">{{ formatDateFromNow(props.item.created) }}</td>
              </tr>
            </template>
            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
              From {{ pageStart }} to {{ pageStop }}
            </template>
          </v-data-table>
        </div>
        </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import { formatDate } from '@/components/Mixins/formatDate'
import DisplayAmount from '@/components/Shared/DisplayAmount'

export default {
  components: {
    DisplayAmount
  },
  mixins: [formatDate],
  data () {
    return {
      search: '',
      pagination: {
        descending: true,
        rowsPerPage: -1,
        sortBy: 'created'
      },
      headers: [
        { text: '', value: 'status', align: 'left', class: 'body-2 font-weight-bold' },
        { text: 'Message', value: 'type', align: 'left', class: 'body-2 font-weight-bold' },
        { text: 'Date', value: 'created', align: 'left', class: 'body-2 font-weight-bold' }
      ],
      user: this.$store.getters.user,
      lang: this.$store.getters.group.lang,
      currCode: this.$store.getters.group.currCode,
      currSymbol: this.$store.getters.group.currSymbol
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    notifications () {
      return this.$store.getters.notifications
    },
    groupId () {
      return this.$store.getters.user.group
    }
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  },
  async beforeRouteLeave (to, from, next) {
    const unreadNotificationIDs = this.notifications.filter(notification => notification.status === 'unread')
    var updates = {}

    unreadNotificationIDs.forEach(notification => {
      updates['notifications/' + this.groupId + '/' + notification.id + '/status'] = 'read'
    })
    await firebase.database().ref().update(updates)
    next()
  }
}
</script>
